import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import {
  getPriorityLabel,
  getPriorityClass,
  getStatusClass,
  dateConverted,
} from "../../../controller/global.function.library";

import { ProjectContext } from "../../../model/contexts/project.context";

import "./ProjectListFeed.scss";

const ProjectListFeed = ({
  projectsWithAccess,
  filteredProjects,
  setFilteredProjects,
  selectedMenuTag,
  setSelectedTag,
  setArchiveTag,
  undoArchiveTag,
  setProjectData,
  setIsModalVisible,
  setIsFormEditMode,
  capitalizeFirstLetter,
  setIsUpgradeModalOpen,
  setUpgradeModalTitle,
  setUpgradeModalMessage,
}) => {
  const { deleteSelectedProject, selectProject } = useContext(ProjectContext);

  const navigate = useNavigate();

  // console.log("==== FEED FILTERED PROJECTS ====");
  // filteredProjects.forEach((p, i) => {
  //   console.log(
  //     `#${i}`,
  //     p.name,
  //     "| accessMode:",
  //     p.accessMode,
  //     "| created:",
  //     p.dateCreated || p.createdAt
  //   );
  // });

  const handleDeleteClick = async (selectedProjectId) => {
    try {
      const modifiedArrayWithoutDeletedProject = filteredProjects.filter(
        (project) => project.id !== selectedProjectId,
      );

      const onArchivedTab = selectedMenuTag === "Archived";
      const archivedNowEmpty = modifiedArrayWithoutDeletedProject.length === 0;

      setFilteredProjects(modifiedArrayWithoutDeletedProject);

      if (onArchivedTab && archivedNowEmpty) {
        setSelectedTag("All");
      }

      await deleteSelectedProject(selectedProjectId);
    } catch (error) {
      console.error(
        "handleDeleteClick error:",
        error?.response?.data || error.message,
      );
    }
  };

  const handleViewClick = (project) => {
    selectProject(project);

    localStorage.setItem("selectProjectID", project.id);
    localStorage.setItem("selectProjectName", project.name || "");

    navigate("/task-dashboard");
  };

  const openUpgradeModalForLockedProject = () => {
    setUpgradeModalTitle("Upgrade to edit this project");
    setUpgradeModalMessage(
      "This project is view-only because it is above your current plan’s editable project limit. Upgrade your plan to unlock editing for additional projects.",
    );
    setIsUpgradeModalOpen(true);
  };

  const handleEditClick = (project) => {
    if (project.accessMode === "view") {
      openUpgradeModalForLockedProject();
      return;
    }

    setIsModalVisible(true);

    localStorage.setItem("selectProjectID", project.id);
    localStorage.setItem("selectProjectName", project.name || "");

    setIsFormEditMode(false);
    setProjectData(project);
  };

  const handleArchiveClick = async (project) => {
    await setArchiveTag(project, "archived");
  };

  const handleUnarchiveClick = async (project) => {
    await undoArchiveTag(project, "");
  };

  return (
    <div className="project-list-container">
      <div className="project-list-feed-container">
        {filteredProjects.map((project) => {
          const isArchived =
            project.isArchived ||
            (project.tag || "").toLowerCase() === "archived";
          const isViewOnly = project.accessMode === "view";
          const shouldShowUpgradeToEdit = isViewOnly && !isArchived;
          const shouldShowEditProject = !isViewOnly && !isArchived;

          return (
            <div key={project.id} className="project-container">
              <div className="project-info">
                <div className="project-info-text-container">
                  <div className="project-name-text-container">
                    <div className="project-name-text">{project.name}</div>
                  </div>

                  <div
                    className={`project-status-tag ${getStatusClass(
                      project.status,
                    )}`}
                  >
                    Status: {project.status}
                  </div>
                </div>

                <p className="project-description-text">
                  Summary: {project.description}
                </p>

                <div className="project-description-info-actions">
                  <div className="project-label-container">
                    <p
                      className={`project-priority ${getPriorityClass(
                        project.priority,
                      )}`}
                    >
                      Priority: {getPriorityLabel(project.priority)}
                    </p>

                    {/* {project.tag && project.tag.trim() !== "" && (
                      <p className="project-label">
                        Label: {capitalizeFirstLetter(project.tag)}
                      </p>
                    )} */}
                  </div>

                  <div className="project-actions">
                    <small className="project-list-metadata-custom-required-text">
                      Last Modified:&nbsp;
                      {dateConverted(project.dateModified)}
                    </small>

                    <button
                      className="action-button project-view"
                      onClick={() => handleViewClick(project)}
                    >
                      View Tasks
                    </button>

                    <span className="action-separator">|</span>

                    {shouldShowUpgradeToEdit && (
                      <>
                        <button
                          type="button"
                          className="action-button project-upgrade"
                          onClick={() => handleEditClick(project)}
                        >
                          Upgrade to Edit
                        </button>

                        <span className="action-separator">|</span>
                      </>
                    )}

                    {shouldShowEditProject && (
                      <>
                        <button
                          type="button"
                          className="action-button project-edit"
                          onClick={() => handleEditClick(project)}
                        >
                          Edit Project
                        </button>

                        <span className="action-separator">|</span>
                      </>
                    )}

                    {selectedMenuTag !== "Archived" ? (
                      <button
                        className="action-button project-archive"
                        onClick={() => handleArchiveClick(project)}
                      >
                        Archive
                      </button>
                    ) : (
                      <>
                        <button
                          className="action-button project-unarchive"
                          onClick={() => handleUnarchiveClick(project)}
                        >
                          Unarchive
                        </button>

                        <span className="action-separator">|</span>

                        <button
                          className="action-button project-delete"
                          onClick={() => handleDeleteClick(project.id)}
                        >
                          Delete
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProjectListFeed;
